var render, staticRenderFns
import script from "./EmployeeCard.vue?vue&type=script&lang=ts&"
export * from "./EmployeeCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ffb12e",
  null
  
)

export default component.exports